/** @format */
import dynamic from "next/dynamic";
import { Layout } from "../../components/common/Layout";
import { useRouter } from "next/router";
import { v4 as uuidv4 } from "uuid";
const NotFound = dynamic(() => import("../../components/NotFound/NotFound"));
const Spinner = dynamic(() => import("../../components/Spinner/Spinner"));
const ProductDescription = dynamic(() =>
  import("../../components/ProductDescription/ProductDescription")
);


export default function ProductDescriptionPage({ data = {}, articleId }) {
  const router = useRouter();
  const { productDetails = {} } = data || {};
  const categories = productDetails?.categoryDescs
    ? productDetails.categoryDescs
    : "home decor & fashion, home and lifestyle";
  // const adjCategories =
  //   categories.length > 23 ? `${categories.substring(0, 20)}...` : categories;
  const productName = productDetails?.productName
    ? productDetails.productName
    : "";
  const adjProdName =
    productName.length > 23
      ? `${productName.substring(0, 20)}...`
      : productName;

  const meta = {
    title: `Source ${adjProdName} | Qalara`,
    description: `Looking to buy ${productName} from Indian suppliers? Shop home & lifestyle goods wholesale.`,
    keywords: `${productName} suppliers, handcrafted online, Wholesale ${categories}, source ${productName} online, ${categories} manufacturers, ${categories} exporters`,
    url: "/product/" + articleId + "/",
  };
  

  if (data?.error?.status) {
    return (
      <>
        <NotFound />
      </>
    );
  }

  if (router.isFallback) {
    return <Spinner />;
  }
  return (
    <Layout meta={meta}>
      <ProductDescription data={data} />
    </Layout>
  );
}

export async function getStaticPaths() {
  let res, paths;
  let posts = [
    {
      id: "50101513246",
    },
  ];
  try {
    const response = await fetch(
      process.env.NEXT_PUBLIC_REACT_APP_API_PRODUCT_DESCRIPTION_URL +
        `/products/data/published`,
      {
        method: "GET",
      }
    );
    res = await response.json();
    posts = res || [];
    paths = posts.map((post) => {
      if (post) {
        return {
          params: { articleId: post },
        };
      }
    });
  } catch (error) {}
  return {
    paths: [],
    fallback: true,
  };
}

export const getStaticProps = async ({ params: { articleId = "" } = {} }) => {
  let res = { productDetails: {}, listingPage: {} };
  let error = { status: false };


  try {
    // First API call - Get product details
    const response = await fetch(
      process.env.NEXT_PUBLIC_REACT_APP_API_PRODUCT_DESCRIPTION_URL +
        `/price/v2/product/PRODUCT::${articleId}?currency=USD`,
      {
        method: "GET",
        headers: {
          Authorization: "Bearer " + process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN,
        },
      }
    );

    if (!response.ok) {
      throw new Error(`Failed to fetch product details: ${response.status}`);
    }

    const productDetailArr = await response.json();

  

    if (!productDetailArr || !Array.isArray(productDetailArr) || productDetailArr.length === 0) {
      res["error"] = true;
    } else {
      res["productDetails"] = productDetailArr[0];
    }

    if (res["productDetails"]?.sellerCode && res["productDetails"]?.l3Name) {
      const { sellerCode, l3Name } = res.productDetails;
      const l3NameParsed = encodeURIComponent(l3Name);

      // Second API call - Get listing page data
      const responseListingPage = await fetch(
        `${process.env.NEXT_PUBLIC_REACT_APP_CONTENT_BFF_URL}/search/v1/seller-product-search?from=0&size=15&sort_by=minimumOrderQuantity&sort_order=ASC&sellerId=${sellerCode}&bird=lion&f_l3_names=${l3NameParsed}`,
        {
          method: "GET",
          headers: {
            "trace-id": uuidv4(),
            Authorization: `Bearer ${process.env.NEXT_PUBLIC_ANONYMOUS_TOKEN}`,
          },
        }
      );

      if (!responseListingPage.ok) {
        throw new Error(`Failed to fetch listing page: ${responseListingPage.status}`);
      }

      const listingData = await responseListingPage.json();

      res["listingPage"] = {
        ...listingData,
        slp_count: listingData.totalHits || 0,
        slp_facets: listingData.aggregates || [],
        slp_content: listingData.products || [],
        slp_categories: listingData.fixedAggregates || [],
      };
    }
  } catch (err) {
    console.error("Error in getStaticProps:", err);
    error["status"] = true;
  }

  return {
    props: {
      data: res,
      error,
      articleId: articleId || null,
    },
    revalidate: 10,
  };
};
